import moment from 'moment'
import 'moment/locale/es'
import {cuentaMask, dineroDisabledMask, round2Decimals} from '../Components/Items'
import conceptoConTipoDeCambio from './conceptoTipoCambio'
import polizaPdfV2 from './PdfV2.0/polizaPdfV2'

moment.locale('es')

const polizaPdf = (values) => {
    const empresa = values.empresa

    // Diseño moderno (Configuración → PDF): misma póliza, otra plantilla. Es formato, no dato,
    // así que aplica también a las pólizas viejas y a las ya timbradas.
    if (empresa.tipoPDF === "moderno") return polizaPdfV2(values)

    const poliza = values.poliza
    const detallada = !!values.detallada
    const documentos = values.documentos || []
    let ied
    let iedInicial
    if(poliza.tipodepoliza.tipoDePolizaId === 1){
        ied = 'Ingreso'
        iedInicial = 'I'
    }
    if(poliza.tipodepoliza.tipoDePolizaId === 2){
        ied = 'Egreso'
        iedInicial = 'E'
    }
    if(poliza.tipodepoliza.tipoDePolizaId === 3){
        ied = 'Traslado'
        iedInicial = 'T'
    }
    if(poliza.tipodepoliza.tipoDePolizaId === 4){
        ied = 'Nomina'
        iedInicial = 'N'
    }
    if(poliza.tipodepoliza.tipoDePolizaId === 5){
        ied = 'Pago'
        iedInicial = 'P'
    }
    if(poliza.tipodepoliza.tipoDePolizaId === 6){
        ied = 'Diario'
        iedInicial = 'D'
    }
    let cargosTotal = 0
    let abonosTotal = 0
    const proyectosDistintos = new Set(values.cargosabonos.map(valueCA => valueCA.proyectoId || valueCA.proyecto?._id))
    const mostrarColumnaProyecto = proyectosDistintos.size > 1
    // Vista previa: renglones cuya subcuenta de empleado todavía no existe. El backend
    // manda el código con el que se va a crear (cuentaProyectada), así que aquí solo
    // hay que marcarlos y explicar la marca al pie — si no, se leen como cuentas reales.
    const cuentasPorCrear = values.cargosabonos.filter(valueCA => valueCA.cuentaPorConfirmar)
    // Pólizas con varios proyectos adentro —la de nómina junta todos los departamentos y
    // pasa de los cientos de renglones— se ordenan por proyecto, con un subtotal al cerrar
    // cada uno y un desglose al pie. Con un solo proyecto no cambia absolutamente nada.
    const SIN_PROYECTO = 'SIN PROYECTO'
    const nombreProyecto = (valueCA) => valueCA.proyecto?.nombre || SIN_PROYECTO
    // Misma expresión que proyectosDistintos: la vista previa de nómina manda proyecto pero
    // no proyectoId. Sin proyecto resuelto todos los renglones caen en un mismo grupo.
    const claveProyecto = (valueCA) => valueCA.proyecto?.nombre ? `${valueCA.proyectoId || valueCA.proyecto._id}` : ''
    // Los niveles son String con default null en el modelo, y la cuenta puede venir nula.
    const codigoCuenta = (valueCA) => {
        const cuenta = valueCA.cuentacontable
        if(!cuenta) return ''
        return `${cuenta.nivel1 || ''}${cuenta.nivel2 || ''}${cuenta.nivel3 || ''}${cuenta.nivel4 || ''}${cuenta.nivel5 || ''}`
    }
    const cargosabonos = mostrarColumnaProyecto
        ? [...values.cargosabonos].sort((a, b) => {
            const sinProyectoA = !a.proyecto?.nombre
            const sinProyectoB = !b.proyecto?.nombre
            if(sinProyectoA !== sinProyectoB) return sinProyectoA ? 1 : -1
            return nombreProyecto(a).localeCompare(nombreProyecto(b), 'es', {sensitivity: 'base', numeric: true})
                || (b.cargo ? 1 : 0) - (a.cargo ? 1 : 0)
                || codigoCuenta(a).localeCompare(codigoCuenta(b), 'es', {numeric: true})
                || `${a.concepto || ''}`.localeCompare(`${b.concepto || ''}`, 'es', {sensitivity: 'base'})
        })
        : values.cargosabonos
    const resumenProyectos = []
    // Con mostrarColumnaProyecto la tabla siempre trae 6 columnas: el rótulo abarca las
    // primeras cuatro (77% del ancho) y los importes se alinean con Cargo y Abono.
    const filaSubtotal = (grupo) => ([
        {text: 'Subtotal '+grupo.nombre, colSpan: 4, style: 'textoMuyChico', bold: true, alignment: 'left', fillColor: '#e6f7ff'},
        {}, {}, {},
        {text: dineroDisabledMask(grupo.cargos), style: 'textoMuyChico', bold: true, alignment: 'right', fillColor: '#e6f7ff'},
        {text: dineroDisabledMask(grupo.abonos), style: 'textoMuyChico', bold: true, alignment: 'right', fillColor: '#e6f7ff'},
    ])
    let cargosAbonosTable = []
    let grupoActual = null
    for(const valueCA of cargosabonos){
        let cargos = 0
        let abonos = 0
        if(valueCA.cargo){
            cargos = valueCA.monto
            cargosTotal += valueCA.monto
        }else{
            abonos = valueCA.monto
            abonosTotal += valueCA.monto
        }
        if(mostrarColumnaProyecto){
            const clave = claveProyecto(valueCA)
            if(!grupoActual || grupoActual.clave !== clave){
                if(grupoActual) cargosAbonosTable.push(filaSubtotal(grupoActual))
                grupoActual = {clave, nombre: nombreProyecto(valueCA), movimientos: 0, cargos: 0, abonos: 0}
                resumenProyectos.push(grupoActual)
            }
            grupoActual.movimientos += 1
            grupoActual.cargos = round2Decimals(grupoActual.cargos + cargos)
            grupoActual.abonos = round2Decimals(grupoActual.abonos + abonos)
        }
        const marca = valueCA.cuentaPorConfirmar ? ' *' : ''
        cargosAbonosTable.push([
            {text: cuentaMask(valueCA.cuentacontable.nivel1+valueCA.cuentacontable.nivel2+valueCA.cuentacontable.nivel3+valueCA.cuentacontable.nivel4+valueCA.cuentacontable.nivel5) + marca, style: 'textoMuyChico',  alignment: 'left'},
            {text: valueCA.cuentacontable.descripcion, style: 'textoMuyChico', alignment: 'left'},
            ...(mostrarColumnaProyecto ? [{text: valueCA.proyecto?.nombre || '', style: 'textoMuyChico', alignment: 'left'}] : []),
            {text: conceptoConTipoDeCambio(valueCA.concepto, valueCA.tipoDeCambio), style: 'textoMuyChico', alignment: 'left'},
            {text: cargos === 0 ? '-' : dineroDisabledMask(cargos), style: 'textoMuyChico', alignment: 'right'},
            {text: abonos === 0 ? '-' : dineroDisabledMask(abonos), style: 'textoMuyChico', alignment: 'right'},
        ])
    }
    if(grupoActual) cargosAbonosTable.push(filaSubtotal(grupoActual))
    let cancelado = {}
    if(poliza.estado === 0){
    cancelado = {watermark: { text: 'CANCELADO', color: 'GRAY', opacity: 0.3, bold: true, italics: false, angle: -50, fontSize: 110 }}}
    else if(poliza.esPreview){
    cancelado = {watermark: { text: 'VISTA PREVIA', color: '#1677ff', opacity: 0.15, bold: true, italics: false, angle: -50, fontSize: 90 }}}
    var dd = {
        ...cancelado,
        content: [
            {
                style: 'tableExample',
                table: {
                    widths: [ '18%', '52%', '30%'],
                    layout: {
                        defaultBorder: false,
                    },
                    body: [
                        [
                            {
                                border: [false, false, false, false],
                                image: 'logo',
                                fit: [80, 80]
                            },
                            {
                                border: [false, false, false, false],
                                table: {
                                  headerRows: 1,
                                  widths: ["100%"],

                                  body: [
                                    [
                                        {
                                        text: empresa.nombreComercial ? empresa.nombreComercial : (empresa.persona ? empresa.nombre : empresa.nombre+' '+empresa.apellidoPaterno+' '+empresa.apellidoMaterno),
                                        style: "tableHeader"
                                        }
                                    ],
                                    [
                                      {
                                        text: "R.F.C: "+empresa.rfc,
                                        style: "textoChico",
                                        alignment: "center",
                                      },
                                    ],
                                    [
                                        {
                                          text: empresa.calle+' '+
                                                empresa.numeroCalle+' '+
                                                (empresa.numeroInterior ? empresa.numeroInterior : '')
                                          ,
                                          style: "textoChico",
                                          alignment: "center",
                                        },
                                      ],
                                    [
                                        {
                                          text: empresa.colonia.tipoAsentamiento+' '+
                                          empresa.colonia.nombre+' C.P. '+
                                          empresa.colonia.cp+' '+
                                          empresa.municipio.nombre+' '+
                                          empresa.estado.abreviatura+' '+
                                          empresa.pais.abreviatura+' '
                                          ,
                                          style: "textoChico",
                                          alignment: "center",
                                        },
                                      ],
                                    // empresa.telefono ? [
                                    //     {
                                    //         text: 'Tel: '+phoneMask(empresa.telefono),
                                    //         style: "textoChico",
                                    //         alignment: "center",
                                    //       },
                                    // ] : [],
                                    [
                                        {
                                          text: 'Regimen Fiscal: ('+empresa.regimenFiscal.c_RegimenFiscal+') '+empresa.regimenFiscal.descripcion
                                          ,
                                          style: "textoChico",
                                          alignment: "center",
                                        },
                                      ],
                                      [
                                        {
                                          text: 'Tipo De Comprobante: ('+iedInicial+') '+ied,
                                          style: "textoChico",
                                          alignment: "center",
                                        },
                                      ],
                                  ],
                                },
                                layout: "noBorders",
                              },
                            {
                                border: [false, false, false, false],
                                    table: {
                                    headerRows: 1,
                                    widths: ['35%', '65%'],

                                    body: [
                                        [{text: 'Poliza:', style: 'subheader', alignment: 'left'},
                                        {text: ied+': '+poliza.numeroTipoTipoPoliza, style: 'textoChico', alignment: 'left'}],
                                        [{text: '', style: 'subheader', alignment: 'left'},
                                        {text: poliza.tipodepoliza.descripcion+': '+poliza.numeroTipoPoliza, style: 'textoChico', alignment: 'left'}],
                                        [{text: 'Tipo de Poiza:', style: 'subheader', alignment: 'left'},
                                        {text: '('+iedInicial+') '+ied, style: 'textoChico', alignment: 'left'}],
                                        [{text: 'Fecha:', style: 'subheader', alignment: 'left'},
                                        {text: moment(poliza.fechaRegistro).locale('es').format('LL'), style: 'textoChico', alignment: 'left'}],
                                        // Con renglones de varios proyectos, el del encabezado es solo
                                        // el principal: el reparto real esta en el Desglose por Proyecto.
                                        [{text: mostrarColumnaProyecto ? 'Proyecto principal:' : 'Proyecto:', style: 'subheader', alignment: 'left'},
                                        {text: poliza.proyecto.nombre+' '+poliza.proyecto.descripcion, style: 'textoChico', alignment: 'left'}],
                                        [{text: 'Sub Proyecto:', style: 'subheader', alignment: 'left'},
                                        { text: poliza?.subproyecto ?  poliza.subproyecto.codigo + ' - ' + poliza.subproyecto.nombre : 'N/A'  , style: 'textoChico', alignment: 'left' }],
                                        [{text: 'Detallada:', style: 'subheader', alignment: 'left'},
                                        {text: detallada ? 'Sí' : 'No', style: 'textoChico', alignment: 'left'}],
                                        poliza.numeroCheque ? [{text: 'N° Cheque:', style: 'subheader', alignment: 'left'},
                                        {text: String(poliza.numeroCheque), style: 'textoChico', alignment: 'left'}] : null,
                                    ].filter(Boolean)
                                },
                                layout: 'noBorders'
                            },
                        ]

                    ]
                },
            },
            {
                style: 'tableExample',
                table: {
                    // widths: ['60%', '5%', '35%'],
                    layout: {
                        defaultBorder: false,
                     },
                    body: [
                            [
                              {text: 'Concepto: '+poliza.concepto, style: 'subheader',},
                            //   {text: 'UUID:', style: 'textoChico'},
                            //   {text: 'Variable UUID', style: 'textoChico'}
                            ]
                       ]
                },
                            layout: {
                    hLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.body.length) ? 1 : 1;
                    },
                    vLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.widths.length) ? 1 : 1;
                    },
                    hLineColor: function (i, node) {
                        return '#adaaaa';
                    },
                    vLineColor: function (i, node) {
                        return '#adaaaa';
                    },
                    hLineStyle: function (i, node) {
                        if (i === 0 || i === node.table.body.length) {
                            return null;
                        }
                        return {dash: {length: 2, space: 1}};
                    },
                    vLineStyle: function (i, node) {
                        if (i === 0 || i === node.table.widths.length) {
                            return null;
                        }
                        return {dash: {length: 2}};
                    },
                }

            },

            {
                style: 'tableExample',
                table: {
                    // Una póliza de nómina se va a varias páginas: sin headerRows los títulos
                    // de columna sólo salen en la primera y el resto se lee a ciegas.
                    headerRows: 1,
                    widths: mostrarColumnaProyecto ? ['11%', '27%', '17%', '22%', '11%', '12%'] : ['13%', '33%', '28%', '13%', '13%'],
                    layout: {
                        defaultBorder: true,
                    },
                    body: [
                        [
                          {text: 'Cuenta', style: 'tituloTabla', fontSize: 7},
                          {text: 'Descripción', style: 'tituloTabla', fontSize: 7},
                          ...(mostrarColumnaProyecto ? [{text: 'Proyecto', style: 'tituloTabla', fontSize: 7}] : []),
                          {text: 'Concepto', style: 'tituloTabla', fontSize: 7},
                          {text: 'Cargo', style: 'tituloTabla', fontSize: 7},
                          {text: 'Abono', style: 'tituloTabla', fontSize: 7},

                        ],
                        ...cargosAbonosTable
                    ]
                },
                layout: {
                    fillColor: (rowIndex, node, columnIndex) => {
                        return rowIndex % 2 === 0 ? "#f5f5f5" : "#ffffff";
                    },
                    hLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.body.length) ? 1 : 1;
                    },
                    vLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.widths.length) ? 1 : 1;
                    },
                    hLineColor: function (i, node) {
                        return '#adaaaa';
                    },
                    vLineColor: function (i, node) {
                        return '#adaaaa';
                    },
                    hLineStyle: function (i, node) {
                        if (i === 0 || i === node.table.body.length) {
                            return null;
                        }
                        return {dash: {length: 2, space: 1}};
                    },
                    vLineStyle: function (i, node) {
                        if (i === 0 || i === node.table.widths.length) {
                            return null;
                        }
                        return {dash: {length: 2}};
                    },
                }
            },
            {
                alignment: 'right',
              table: {
                  widths: ['15%', '28%', '18%','13%', '13%', '13%'],
                  layout: {
                    defaultBorder: false,
                  },
                  body: [
                      [
                        {border: [false,false, false,false], text: '', style: 'subheader',},
                        {border: [false,false, false,false], text: '', style: 'subheader',},
                        {border: [false,false, false,false], text: '', style: 'subheader',},
                        {border: [false,false, false,false], text: 'Total:', style: 'subheader', fontSize: 7},
                        {border: [false,false, false,false], text: dineroDisabledMask(cargosTotal), style: 'textoMuyChico',},
                        {border: [false,false, false,false], text: dineroDisabledMask(abonosTotal), style: 'textoMuyChico', alignment: 'right'}
                      ],
                  ]
              },
            },
            // Desglose por proyecto. La Diferencia debe dar cero en cada renglón: la nómina
            // emite renglones intercentro (Empresa.cuentaIntercentroId) justo para que cada
            // proyecto cuadre por separado. Si no da cero, esa cuenta no está configurada.
            ...(mostrarColumnaProyecto ? [
                {text: 'Desglose por Proyecto', style: 'subheader', margin: [0, 10, 0, 4]},
                {
                    style: 'tablaSinMargen',
                    table: {
                        headerRows: 1,
                        widths: ['34%', '10%', '19%', '19%', '18%'],
                        body: [
                            [
                                {text: 'Proyecto', style: 'tituloTabla', fontSize: 7},
                                {text: 'Movs.', style: 'tituloTabla', fontSize: 7},
                                {text: 'Cargos', style: 'tituloTabla', fontSize: 7},
                                {text: 'Abonos', style: 'tituloTabla', fontSize: 7},
                                {text: 'Diferencia', style: 'tituloTabla', fontSize: 7},
                            ],
                            ...resumenProyectos.map(grupo => {
                                const diferencia = round2Decimals(grupo.cargos - grupo.abonos)
                                return [
                                    {text: grupo.nombre, style: 'textoMuyChico', alignment: 'left'},
                                    {text: String(grupo.movimientos), style: 'textoMuyChico', alignment: 'right'},
                                    {text: dineroDisabledMask(grupo.cargos), style: 'textoMuyChico', alignment: 'right'},
                                    {text: dineroDisabledMask(grupo.abonos), style: 'textoMuyChico', alignment: 'right'},
                                    {text: dineroDisabledMask(diferencia), style: 'textoMuyChico', alignment: 'right', ...(diferencia !== 0 ? {bold: true, color: '#cf1322'} : {})},
                                ]
                            }),
                            [
                                {text: 'TOTAL', style: 'textoMuyChico', bold: true, alignment: 'left', fillColor: '#e6f7ff'},
                                {text: String(cargosabonos.length), style: 'textoMuyChico', bold: true, alignment: 'right', fillColor: '#e6f7ff'},
                                {text: dineroDisabledMask(cargosTotal), style: 'textoMuyChico', bold: true, alignment: 'right', fillColor: '#e6f7ff'},
                                {text: dineroDisabledMask(abonosTotal), style: 'textoMuyChico', bold: true, alignment: 'right', fillColor: '#e6f7ff'},
                                {text: dineroDisabledMask(round2Decimals(cargosTotal - abonosTotal)), style: 'textoMuyChico', bold: true, alignment: 'right', fillColor: '#e6f7ff'},
                            ],
                        ]
                    },
                    layout: {
                        fillColor: (rowIndex) => rowIndex % 2 === 0 ? '#f5f5f5' : '#ffffff',
                        hLineWidth: () => 1,
                        vLineWidth: () => 1,
                        hLineColor: () => '#adaaaa',
                        vLineColor: () => '#adaaaa',
                    }
                }
            ] : []),
            // Leyenda de las subcuentas por crear. Solo aparece en la vista previa:
            // en la póliza real ya no hay ningún renglón con cuentaPorConfirmar.
            ...(cuentasPorCrear.length > 0 ? [
                {
                    margin: [0, 6, 0, 0],
                    table: {
                        widths: ['*'],
                        body: [[{
                            border: [false, false, false, false],
                            fillColor: '#FFF7E6',
                            margin: [8, 6, 8, 6],
                            stack: [
                                {
                                    text: `* ${cuentasPorCrear.length} ${cuentasPorCrear.length === 1 ? 'cuenta marcada con asterisco todavía no existe' : 'cuentas marcadas con asterisco todavía no existen'}: ${cuentasPorCrear.length === 1 ? 'se dará de alta' : 'se darán de alta'} automáticamente con ese código al generar la póliza.`,
                                    style: 'textoMuyChico',
                                    bold: true,
                                },
                                {
                                    text: 'El código puede recorrerse si antes se dan de alta otras cuentas bajo la misma cuenta mayor.',
                                    style: 'textoMuyChico',
                                    margin: [0, 2, 0, 0],
                                },
                            ],
                        }]],
                    },
                    layout: { defaultBorder: false },
                },
            ] : []),
            ...(documentos.length > 0 ? [
                {text: 'Documentos Fiscales', style: 'subheader', margin: [0, 10, 0, 4]},
                {
                    style: 'tableExample',
                    table: {
                        widths: ['8%', '9%', '30%', '11%', '32%', '10%'],
                        body: [
                            [
                                {text: 'Tipo', style: 'tituloTabla', fontSize: 7},
                                {text: 'SAT', style: 'tituloTabla', fontSize: 7},
                                {text: 'UUID', style: 'tituloTabla', fontSize: 7},
                                {text: 'Referencia', style: 'tituloTabla', fontSize: 7},
                                {text: 'Descripción', style: 'tituloTabla', fontSize: 7},
                                {text: 'Monto', style: 'tituloTabla', fontSize: 7},
                            ],
                            ...documentos.map((doc) => {
                                let referencia = ''
                                let descripcion = ''
                                let monto = ''
                                let sat = ''
                                if (doc.tipo === 'venta') {
                                    referencia = doc.serieNumero || ''
                                    descripcion = doc.concepto || ''
                                    monto = doc.total != null ? dineroDisabledMask(doc.total) : ''
                                    sat = 'Ingreso'
                                } else if (doc.tipo === 'factura') {
                                    referencia = [doc.codigoFactura, doc.numeroFactura].filter(Boolean).join(' ')
                                    descripcion = doc.descripcion || ''
                                    sat = 'Ingreso'
                                } else if (doc.tipo === 'pago') {
                                    referencia = doc.serieNumero || ''
                                    descripcion = doc.fechaPago ? moment(doc.fechaPago).format('DD/MM/YYYY') : ''
                                    monto = doc.monto != null ? dineroDisabledMask(doc.monto) : ''
                                    sat = 'Pago'
                                }
                                return [
                                    {text: doc.tipo.charAt(0).toUpperCase() + doc.tipo.slice(1), style: 'textoMuyChico', alignment: 'left'},
                                    {text: sat, style: 'textoMuyChico', alignment: 'left'},
                                    {text: doc.uuid || '', style: 'textoMuyChico', alignment: 'left'},
                                    {text: referencia, style: 'textoMuyChico', alignment: 'left'},
                                    {text: descripcion, style: 'textoMuyChico', alignment: 'left'},
                                    {text: monto, style: 'textoMuyChico', alignment: 'right'},
                                ]
                            })
                        ]
                    },
                    layout: {
                        fillColor: (rowIndex) => rowIndex % 2 === 0 ? '#f5f5f5' : '#ffffff',
                        hLineWidth: () => 1,
                        vLineWidth: () => 1,
                        hLineColor: () => '#adaaaa',
                        vLineColor: () => '#adaaaa',
                    }
                }
            ] : []),
        ],
        images: {
            logo: empresa.logo.base64Completa,
        },
        styles: {
            header: {
                fontSize: 9,
                bold: true,
            },
            subheader: {
                fontSize: 8,
                bold: true,
            },
            tableExample: {
                margin: [0, 5, 0, 5]
            },
            tablaSinMargen: {
                margin: [0, 0, 0, 0]
            },
            tableHeader: {
                bold: true,
                fontSize: 12,
                color: 'black',
                alignment: 'center'
            },
            textoChico:{
                fontSize: 8
            },
            textoMuyChico:{
                fontSize: 7
            },
            tituloTabla:{
                fontSize: 8,
                bold: true,
                fillColor: '#cccccc',
                style: 'subheader',
                alignment: 'center',
                border: true
            },
            textoTabla: {
                fontSize: 8,
                italics: false
            }
        },
        pageSize: 'LETTER',
        // pageMargins: [ 20, 20, 20, 20 ],
    }
  return dd;
};


export default polizaPdf;
